import React from 'react';
import NextButton from '~/components/shared/Stepper/components/NextButton';
import useSubmit from '../../Steps/useSubmit';
import { useSelector } from 'react-redux';
import { RootState } from '~/store';
import { ApiStatus } from '~/store/types/sharedTypes';
import useGoToNextStep from '../../Steps/useGoToNextStep';
import useStepConfig from '../../Steps/useStepConfig';

export const BankConnectionFooter = () => {
  const {
    loanApplication: {
      apiStatus,
      form: { bankConnected },
    },
  } = useSelector((state: RootState) => state);

  const { isLastStep } = useStepConfig();

  const onSubmit = useSubmit();
  const onNextStepClick = useGoToNextStep();

  const label = isLastStep
    ? `${bankConnected ? 'Onboarding.Submit' : 'Onboarding.SkipAndSubmit'}`
    : `${bankConnected ? 'Onboarding.Next' : 'Onboarding.Skip'}`;

  return (
    <NextButton
      label={label}
      isLoading={apiStatus.patch === ApiStatus.Started}
      action={isLastStep ? onSubmit : onNextStepClick}
      compact
    />
  );
};
